import { render, staticRenderFns } from "./CompetitionRegistrationActionCrudComponent.vue?vue&type=template&id=5c757475&scoped=true"
import script from "./CompetitionRegistrationActionCrudComponent.vue?vue&type=script&lang=ts"
export * from "./CompetitionRegistrationActionCrudComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c757475",
  null
  
)

export default component.exports